import { useLayoutEffect, useRef } from "preact/hooks";

/** 同时处理草稿恢复、输入和宽度变化；只改变输入区，不改变面板尺寸。 */
export function useComposerSize(
  draft: string,
  open: boolean,
  font: string,
  fontSize: string,
) {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const input = inputRef.current;
    const frame = input?.parentElement;
    if (!open || !input || !frame) return;
    const resize = () => {
      const style = getComputedStyle(input);
      const padding =
        parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      // scrollHeight 是整数，向上取整避免小数行高在第四行提前溢出。
      const maxHeight = Math.ceil(parseFloat(style.lineHeight) * 4 + padding);
      const scrollTop = input.scrollTop;
      // 收成 0 量高时外框不能跟着变矮：旁边的消息列表会跟着变高，浏览器把贴底的滚动位置夹回去，
      // 还原后列表就往下跳一行（GON-163）。
      frame.style.height = getComputedStyle(frame).height;
      input.style.height = "0px";
      const height = input.scrollHeight;
      input.style.height = `${String(Math.min(height, maxHeight))}px`;
      frame.style.height = "";
      input.style.overflowY = height > maxHeight ? "auto" : "hidden";
      input.scrollTop = scrollTop;
    };
    resize();
    let width = input.clientWidth;
    const observer = new ResizeObserver(() => {
      if (input.clientWidth === width) return;
      width = input.clientWidth;
      resize();
    });
    observer.observe(input);
    // 宿主字体异步加载后，换行位置也可能改变。
    if (typeof document.fonts !== "undefined")
      document.fonts.addEventListener("loadingdone", resize);
    return () => {
      observer.disconnect();
      if (typeof document.fonts !== "undefined")
        document.fonts.removeEventListener("loadingdone", resize);
    };
  }, [draft, open, font, fontSize]);
  return inputRef;
}
